import { render } from "./OutpostRepair.vue?vue&type=template&id=785a9e9e"
import script from "./OutpostRepair.vue?vue&type=script&lang=js"
export * from "./OutpostRepair.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__